import Fxs from "./effects/fxs";
import Grids from "./elements/grids";
import tools from './tools/tools';
import TopNav from './elements/top-nav';
import Stats from 'three/examples/jsm/libs/stats.module';
import animations from './elements/animations'
import lightbox from './elements/lightbox'



const isStats = false;

window.airtheme = {};

if (window.NodeList && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}
if (!Element.prototype.matches) {
	Element.prototype.matches = Element.prototype.matchesSelector ||
	Element.prototype.webkitMatchesSelector ||
	Element.prototype.mozMatchesSelector ||
	Element.prototype.msMatchesSelector;
}
// :scope polyfill
(function(doc, proto) {
  try { // check if browser supports :scope natively
    doc.querySelector(':scope body');
  } catch (err) { // polyfill native methods if it doesn't
    ['querySelector', 'querySelectorAll'].forEach(function(method) {
      var nativ = proto[method];
      proto[method] = function(selectors) {
        if (/(^|,)\s*:scope/.test(selectors)) { // only if selectors contains :scope
          var id = this.id; // remember current element id
          this.id = 'ID_' + Date.now(); // assign new unique id
          selectors = selectors.replace(/((^|,)\s*):scope/g, '$1#' + this.id); // replace :scope with #ID
          var result = doc[method](selectors);
          this.id = id; // restore previous id
          return result;
        } else {
          return nativ.call(this, selectors); // use native code for other selectors
        }
      }
    });
  }
})(window.document, Element.prototype);
class Script{
	constructor(){
		this.htmlEl = document.documentElement;
		this.templateUri = airthemeWP.templateUri;
		this.extUri = airthemeWP.extUri;
		this.fxRestore = new Set()
		this.scrollHandlers = new Set();
	}
	fxStop(){
		this.isFxStop = true;
	}
	fxStart(){
		this.isFxStop = false;
		this.fxRestore.forEach((f)=>{
			this.fxRestore.delete(f)
			f()
		})
	}
	ready(){
		this.isPreviewClass = 'block-editor-block-preview__content-iframe';
		this.isPreviewMode = document.documentElement.classList.contains(this.isPreviewClass);
		this.isTheme = document.body.classList.contains('airtheme-theme')
		this.baseUri = this.isTheme ? this.templateUri : this.extUri
		this.simplifiedFxOn = ()=>{
			this.simplifiedFx = true
			document.documentElement.classList.add('airtheme-fx-simplified');
		}
		if(this.isPreviewMode){
			this.simplifiedFxOn();
		}else{
			this.simplifiedFx = (getComputedStyle(document.body).getPropertyValue('--airtheme-fx-simplified') == 1) ? true : false
		}
		const me = this;
		this.isSafari = document.body.classList.contains('airtheme-is-safari')
		if(this.isTheme && !this.isPreviewMode){
			if(isStats){
				const stats = new Stats();
				document.body.appendChild( stats.dom );
				stats.dom.style.zIndex = 1000000;
				const animateStats = function(time){
					requestAnimationFrame(animateStats);
					stats.update();
				}
				requestAnimationFrame(animateStats);
			}
			this.topNav = new TopNav();
			document.querySelectorAll('nav a[href="#"]').forEach(function(el){
				el.addEventListener('click', function(e){
					e.preventDefault();
					return false;
				});
			});
		}
		new Grids();
		if(!this.isPreviewMode){
			lightbox({script: this});
		}
		this.fxs = new Fxs(this, ()=>{
			if(!this.isPreviewMode && !document.documentElement.dataset.airthemeSs){
				animations(this, false);
			}
		});
		this.fxs.ready();
	}
}
let script = new Script();
(function(fn) {
	if (document.attachEvent ? document.readyState === "complete" : document.readyState !== "loading"){
		fn();
	} else {
		document.addEventListener('DOMContentLoaded', fn);
	}
})(script.ready.bind(script));
